import ProjectInformation from './containers/ProjectInformation'

export default ProjectInformation
